module.exports = __webpack_public_path__ + "static/media/info-btn-3.11b00518.jpg";